import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  FormGroup,
  FormFeedback,
  Label,
  Input,
  UncontrolledTooltip,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import AdminEditButtons from '../EditButtons';

import ErrorBoundary from '../../ErrorBoundary';

const AdminUserEditPasswordChange = (props) => {
  const intl = useIntl();

  const {
    profile,
    isSelfEdit,
    errors,
    handleChange,
  } = props;

  const [fieldVisibility, setFieldVisibility] = useState({
    current_password: false,
    new_password: false,
    password_confirmation: false,
  });

  const switchVisibility = (name) => {
    setFieldVisibility(prevState => ({
      ...prevState,
      [name]: !fieldVisibility[name],
    }));
  };

  return (
    <ErrorBoundary>
      <div className="tab-content-wrapper">
        <h4>
          {isSelfEdit ?
            intl.formatMessage({ defaultMessage: 'Your password' }) :
            intl.formatMessage({ defaultMessage: 'User password' })}
        </h4>
        {isSelfEdit ? (
          <p>
            {intl.formatMessage({ defaultMessage: 'Change your password.' })}
          </p>
        ) : (
          <p>
            {intl.formatMessage({ defaultMessage: 'Change user password.' })}
          </p>
        )}
        <div className="user-password">
          <div className="user-password-change">
            {isSelfEdit && (
              <FormGroup>
                <Label for="inpUserPassword">
                  {intl.formatMessage({ defaultMessage: 'Current password' })}
                </Label>
                <div className="form-group-password">
                  <Input
                    type={fieldVisibility.current_password ? 'text' : 'password'}
                    name="current_password"
                    id="inpUserPassword"
                    placeholder="Type current password"
                    onChange={handleChange}
                    invalid={Boolean(errors.current_password)}
                    value={profile.current_password}
                  />
                  <Button
                    id="v-inpUserPassword"
                    color="link"
                    className="password-visibility-switch"
                    onClick={() => { switchVisibility('current_password'); }}
                  >
                    {fieldVisibility.current_password ? (
                      <i className="far fa-eye-slash" />
                    ) : (
                      <i className="far fa-eye" />
                    )}
                  </Button>
                  <UncontrolledTooltip fade={false} target="v-inpUserPassword">
                    {fieldVisibility.current_password ? 'Hide password' : 'Show password'}
                  </UncontrolledTooltip>
                  {errors.current_password && (
                    <FormFeedback>{errors.current_password}</FormFeedback>
                  )}
                </div>
              </FormGroup>
            )}
            <FormGroup>
              <Label for="inpUserNewPassword">
                {intl.formatMessage({ defaultMessage: 'New password' })}
              </Label>
              <div className="form-group-password">
                <Input
                  type={fieldVisibility.new_password ? 'text' : 'password'}
                  name="new_password"
                  id="inpUserNewPassword"
                  placeholder={intl.formatMessage({ defaultMessage: 'Type new password' })}
                  autoComplete="new-password"
                  onChange={handleChange}
                  invalid={Boolean(errors.password)}
                  value={profile.new_password}
                />
                <Button
                  id="v-inpUserNewPassword"
                  color="link"
                  className="password-visibility-switch"
                  onClick={() => { switchVisibility('new_password'); }}
                >
                  {fieldVisibility.new_password ? (
                    <i className="far fa-eye-slash" />
                  ) : (
                    <i className="far fa-eye" />
                  )}
                </Button>
                <UncontrolledTooltip fade={false} target="v-inpUserNewPassword">
                  {fieldVisibility.new_password ? intl.formatMessage({ defaultMessage: 'Hide password' }) : intl.formatMessage({ defaultMessage: 'Show password' })}
                </UncontrolledTooltip>
                {errors.password && (
                  <FormFeedback>{errors.password}</FormFeedback>
                )}
              </div>
            </FormGroup>
            <FormGroup>
              <Label for="inpUserRetypeNewPassword">
                {intl.formatMessage({ defaultMessage: 'Retype new password' })}
              </Label>
              <div className="form-group-password">
                <Input
                  type={fieldVisibility.password_confirmation ? 'text' : 'password'}
                  name="password_confirmation"
                  id="inpUserRetypeNewPassword"
                  placeholder={intl.formatMessage({ defaultMessage: 'Retype new password' })}
                  onChange={handleChange}
                  invalid={Boolean(errors.password_confirmation)}
                  value={profile.password_confirmation}
                />
                <Button
                  id="v-inpUserRetypeNewPassword"
                  color="link"
                  className="password-visibility-switch"
                  onClick={() => { switchVisibility('password_confirmation'); }}
                >
                  {fieldVisibility.password_confirmation ? (
                    <i className="far fa-eye-slash" />
                  ) : (
                    <i className="far fa-eye" />
                  )}
                </Button>
                <UncontrolledTooltip fade={false} target="v-inpUserRetypeNewPassword">
                  {fieldVisibility.password_confirmation ? intl.formatMessage({ defaultMessage: 'Hide password' }) : intl.formatMessage({ defaultMessage: 'Show password' })}
                </UncontrolledTooltip>
                {errors.password_confirmation && (
                  <FormFeedback>{errors.password_confirmation}</FormFeedback>
                )}
              </div>
            </FormGroup>
          </div>
        </div>
      </div>
      <AdminEditButtons
        {...props}
        hideDelete={true}
      />
    </ErrorBoundary>
  );
};

AdminUserEditPasswordChange.propTypes = {
  profile: PropTypes.object.isRequired,
  isSelfEdit: PropTypes.bool.isRequired,
  errors: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default AdminUserEditPasswordChange;
